<div class="hero-section">
    <app-menu-bar></app-menu-bar>
    <div class="darken"></div>
    <div class="overlay-content">
        <div class="pills">
            <div class="pill">
                <img src="assets/images/homepage/brain-icon.svg" alt="">
                <span>{{ 'sol_home_pill_1' | translate }}</span>
            </div>
            <div class="pill">
                <img src="assets/images/homepage/remote-icon.svg" alt="">
                <span>{{ 'sol_home_pill_2' | translate }}</span>
            </div>
            <div class="pill">
                <img src="assets/images/homepage/bolt-icon.svg" alt="">
                <span>{{ 'sol_home_pill_3' | translate }}</span>
            </div>
        </div>

        <span class="title">{{ 'sol_home_hero_title' | translate }}</span>
        <span class="subtitle">{{ 'sol_home_hero_subtitle' | translate }}</span>

        <div class="buttons">
            <button class="primary-btn" (click)="goToUrl('journey')">{{ 'sol_home_hero_cta' | translate }}</button>
        </div>
    </div>
</div>

<section class="cards-section">
    <div class="text-area">
        <div class="pill">{{ 'sol_home_cards_pill' | translate }}</div>
        <span class="title">{{ 'sol_home_cards_title' | translate }}</span>
        <span class="description">{{ 'sol_home_cards_description' | translate }}</span>
    </div>
    <div class="card-area">
        <div class="card teal">
            <div class="inner">
                <svg class="icon" width="32" height="32" viewBox="0 0 32 32" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M27.2038 21.7812C26.2752 22.7097 24.7695 22.7097 23.8409 21.7812L19.7413 17.6813C18.8125 16.7528 18.8125 15.2472 19.7413 14.3186L23.8409 10.2189C24.7695 9.29022 26.2752 9.29022 27.2038 10.2189L31.3036 14.3186C32.2321 15.2472 32.2321 16.7528 31.3036 17.6813L27.2038 21.7812ZM8.15903 21.7812C7.23042 22.7097 5.72481 22.7097 4.79619 21.7812L0.696469 17.6813C-0.232155 16.7528 -0.232157 15.2472 0.696467 14.3186L4.79619 10.2189C5.72481 9.29022 7.23042 9.29022 8.15903 10.2189L12.2588 14.3186C13.1874 15.2472 13.1874 16.7528 12.2588 17.6813L8.15903 21.7812ZM17.6815 31.3034C16.7528 32.2322 15.2472 32.2322 14.3186 31.3034L10.2188 27.2038C9.29021 26.2752 9.29021 24.7695 10.2188 23.8409L14.3186 19.7413C15.2472 18.8125 16.7528 18.8125 17.6815 19.7413L21.7811 23.8409C22.7097 24.7695 22.7097 26.2752 21.7811 27.2038L17.6815 31.3034ZM17.6815 12.2588C16.7528 13.1874 15.2472 13.1874 14.3186 12.2588L10.2188 8.15904C9.29021 7.23042 9.29021 5.72482 10.2188 4.79619L14.3186 0.69647C15.2472 -0.232155 16.7528 -0.232157 17.6815 0.696468L21.7811 4.79619C22.7097 5.72482 22.7097 7.23042 21.7811 8.15904L17.6815 12.2588Z" />
                </svg>

                <span class="title">{{ 'sol_home_card1_title' | translate }}</span>
                <span class="description">{{ 'sol_home_card1_description' | translate }}</span>
            </div>
            <div class="blob"></div>
            <div class="fakeblob"></div>
        </div>

        <div class="card pink">
            <div class="inner">
                <svg class="icon" width="33" height="32" viewBox="0 0 33 32" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <mask id="mask0_352_52" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0"
                        width="33" height="32">
                        <path d="M32.3334 0H0.333374V32H32.3334V0Z" />
                    </mask>
                    <g mask="url(#mask0_352_52)">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M32.3334 8V6.99382e-07L16.3334 0V7.99685C16.3317 3.58002 12.7506 6.99382e-07 8.33337 6.99382e-07H0.333374V16H8.33337C3.9151 16 0.333374 19.5818 0.333374 24L0.333374 32H16.3334V24C16.3334 28.4182 19.9151 32 24.3334 32H32.3334V16H24.3366C28.7534 15.9983 32.3334 12.4172 32.3334 8Z" />
                    </g>
                </svg>

                <span class="title">{{ 'sol_home_card2_title' | translate }}</span>
                <span class="description">{{ 'sol_home_card2_description' | translate }}</span>
            </div>
            <div class="blob"></div>
            <div class="fakeblob"></div>
        </div>

        <div class="card purple">
            <div class="inner">
                <svg class="icon" width="33" height="32" viewBox="0 0 33 32" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M16.6666 5.38318C15.5104 5.38318 14.5732 6.32045 14.5732 7.47664H9.18999C9.18999 3.34741 12.5374 0 16.6666 0C20.7959 0 24.1433 3.34741 24.1433 7.47664C24.1433 11.6059 20.7959 14.9533 16.6666 14.9533V9.5701C17.8228 9.5701 18.7601 8.63282 18.7601 7.47664C18.7601 6.32045 17.8228 5.38318 16.6666 5.38318ZM27.2834 16C27.2834 14.8438 26.3461 13.9065 25.19 13.9065V8.52336C29.3193 8.52336 32.6666 11.8708 32.6666 16C32.6666 20.1293 29.3193 23.4766 25.19 23.4766C21.0607 23.4766 17.7133 20.1293 17.7133 16H23.0965C23.0965 17.1562 24.0338 18.0934 25.19 18.0934C26.3461 18.0934 27.2834 17.1562 27.2834 16ZM8.14327 18.0934C6.98707 18.0934 6.04981 17.1562 6.04981 16C6.04981 14.8438 6.98707 13.9065 8.14327 13.9065C9.29944 13.9065 10.2367 14.8438 10.2367 16H15.6199C15.6199 11.8708 12.2725 8.52336 8.14327 8.52336C4.01403 8.52336 0.666626 11.8708 0.666626 16C0.666626 20.1293 4.01403 23.4766 8.14327 23.4766V18.0934ZM16.6666 26.6168C17.8228 26.6168 18.7601 25.6795 18.7601 24.5234H24.1433C24.1433 28.6526 20.7959 32 16.6666 32C12.5374 32 9.18999 28.6526 9.18999 24.5234C9.18999 20.3941 12.5374 17.0467 16.6666 17.0467V22.4299C15.5104 22.4299 14.5732 23.3672 14.5732 24.5234C14.5732 25.6795 15.5104 26.6168 16.6666 26.6168Z" />
                </svg>

                <span class="title">{{ 'sol_home_card3_title' | translate }}</span>
                <span class="description">{{ 'sol_home_card3_description' | translate }}</span>
            </div>
            <div class="blob"></div>
            <div class="fakeblob"></div>
        </div>
    </div>
</section>

<section class="features-section">
    <div class="text-area">
        <div class="pill">{{ 'sol_home_features_pill' | translate }}</div>
        <span class="title">{{ 'sol_home_features_title' | translate }}</span>
        <span class="description">{{ 'sol_home_features_description' | translate }}</span>
    </div>
    <div class="boxes-wrapper">
        <div class="box">
            <div class="rounded-bg"><img src="assets/images/solution/lock-icon.svg" alt=""></div>
            <span class="title">{{ 'sol_home_box1_title' | translate }}</span>
            <span class="subtitle">{{ 'sol_home_box1_subtitle' | translate }}</span>
        </div>
        <div class="box">
            <div class="rounded-bg"><img src="assets/images/solution/lock-icon.svg" alt=""></div>
            <span class="title">{{ 'sol_home_box2_title' | translate }}</span>
            <span class="subtitle">{{ 'sol_home_box2_subtitle' | translate }}</span>
        </div>
        <div class="box">
            <div class="rounded-bg"><img src="assets/images/solution/lock-icon.svg" alt=""></div>
            <span class="title">{{ 'sol_home_box3_title' | translate }}</span>
            <span class="subtitle">{{ 'sol_home_box3_subtitle' | translate }}</span>
        </div>
        <div class="box">
            <div class="rounded-bg"><img src="assets/images/solution/lock-icon.svg" alt=""></div>
            <span class="title">{{ 'sol_home_box4_title' | translate }}</span>
            <span class="subtitle">{{ 'sol_home_box4_subtitle' | translate }}</span>
        </div>
        <div class="box">
            <div class="rounded-bg"><img src="assets/images/solution/lock-icon.svg" alt=""></div>
            <span class="title">{{ 'sol_home_box5_title' | translate }}</span>
            <span class="subtitle">{{ 'sol_home_box5_subtitle' | translate }}</span>
        </div>
        <div class="box">
            <div class="rounded-bg"><img src="assets/images/solution/lock-icon.svg" alt=""></div>
            <span class="title">{{ 'sol_home_box6_title' | translate }}</span>
            <span class="subtitle">{{ 'sol_home_box6_subtitle' | translate }}</span>
        </div>
    </div>
</section>

<section class="automation-section">
    <img src="assets/images/solution/home.png" alt="" class="section-img">
    <div class="right-side">
        <div class="titles">
            <div class="pill">{{ 'sol_home_automation_pill' | translate }}</div>
            <div class="title">{{ 'sol_home_automation_title' | translate }}</div>
        </div>
        <div class="automations">
            <div class="automation">
                <div class="rounded-bg"><img src="assets/images/solution/lock-icon.svg" alt=""></div>
                <div class="description">{{ 'sol_home_automation1' | translate }}</div>
            </div>
            <div class="automation">
                <div class="rounded-bg"><img src="assets/images/solution/lock-icon.svg" alt=""></div>
                <div class="description">{{ 'sol_home_automation2' | translate }}</div>
            </div>
            <div class="automation">
                <div class="rounded-bg"><img src="assets/images/solution/lock-icon.svg" alt=""></div>
                <div class="description">{{ 'sol_home_automation3' | translate }}</div>
            </div>
        </div>
        <button class="primary-btn" (click)="goToUrl('journey')">{{ 'cta_see_how_it_works' | translate }}</button>
    </div>
</section>

<section class="projects-section">
    <span class="title">{{ 'solution_projects_title' | translate }}</span>
    @if (carouselItems.length) {
    <app-image-carousel [carouselItems]="carouselItems"></app-image-carousel>
    }
</section>

<section class="final-section">
    <div class="banner">
        <span class="title">{{ 'sol_home_final_title' | translate }}</span>
        <span class="description">{{ 'sol_home_final_description' | translate }}</span>
        <div class="button-area">
            <button class="primary-btn" (click)="goToUrl('journey')">{{ 'cta_design_your_space' | translate }}</button>
            <span class="text">{{ 'cta_still_have_questions' | translate }} <span class="highlight">{{ 'cta_contact_us' | translate }}</span></span>
        </div>
    </div>
</section>

<app-footer></app-footer>
